import { api } from "@/lib/api";
import { OUTCOMES, baseFollowup, baseStarter, setDefaultsOverride, toDefault } from "@/lib/liSequences";

const LOCAL = "rcc_li_defaults";
const local = () => { try { return JSON.parse(localStorage.getItem(LOCAL) || "{}"); } catch { return {}; } };
const PH = { first_name: "{first_name}", company: "{company}", open_roles: "{open_roles}", title: "{title}", target_role: "{target_role}", job_title: "{job_title}", id: "", candidate: { headline: "{candidate_headline}", skills: "{candidate_skills}", availability: "{availability}", anonymous: true } };

// Editable built-in emails: [key, name, audience (biz|seeker), kind, detail]
export const DEFAULTS = [
  ["hiring_manager.hiring_help", "LinkedIn follow-up · Hiring managers (they're hiring)", "biz", "Sequence", "3 emails: your open roles, a quick idea, closing the loop"],
  ["hiring_manager.five_min_chat", "LinkedIn follow-up · Hiring managers (5-minute chat)", "biz", "Sequence", "3 emails: thanks for connecting, value follow-up, friendly close"],
  ["mpc_pitch", "LinkedIn · Candidate pitch (MPC)", "biz", "Sequence", "3 emails anchored to their job: candidate intro, snapshot, last call"],
  ["job_seeker", "LinkedIn follow-up · Job seekers", "seeker", "Sequence", "3 emails: free resume scan, how RPOPRO gets you seen, Elite trial"],
  ...OUTCOMES.map(([k, l]) => [`followup.${k}`, `Post-call follow-up · ${l}`, "biz", "Template", "Starting point for the AI follow-up after a call"]),
  ["rescue", "No-show rescue email", "biz", "Automation", "Drafted 1 hour after a no-show; you approve each before it sends"],
];

export const original = (key) => {
  if (key.startsWith("followup.")) return [toDefault({ day: 0, ...baseFollowup(PH, key.split(".")[1], "{next_step}") })];
  if (key === "rescue") return [toDefault({ day: 0, ...baseFollowup(PH, "no_show") })];
  const [audience, goal] = key.split(".");
  return baseStarter({ ...PH, audience, goal }).map(toDefault);
};

export const loadDefaults = async () => {
  let o;
  try { const { data } = await api.get("/admin/rcc/li/defaults"); o = data?.items || {}; } catch { o = local(); }
  setDefaultsOverride(o);
  return o;
};

export const saveDefault = async (key, steps) => {
  try { await api.put(`/admin/rcc/li/defaults/${encodeURIComponent(key)}`, { steps }); return "server"; }
  catch (e) { if (e.response?.status !== 404) throw e; localStorage.setItem(LOCAL, JSON.stringify({ ...local(), [key]: { steps } })); return "local"; }
};

export const resetDefault = async (key) => {
  try { await api.delete(`/admin/rcc/li/defaults/${encodeURIComponent(key)}`); }
  catch (e) { if (e.response?.status !== 404) throw e; const l = local(); delete l[key]; localStorage.setItem(LOCAL, JSON.stringify(l)); }
};

export const SAMPLE = { first_name: "Jordan", last_name: "Kim", company: "Acme", title: "VP Engineering", open_roles: "Senior Solidity Engineer", job_title: "Senior Solidity Engineer", target_role: "Product Manager", id: "sample", candidate: { headline: "Senior Solidity Engineer, 6 yrs DeFi", skills: ["Solidity", "Foundry", "Audits"], availability: "2 weeks notice" } };
